"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useRecommendationCosts = require("../recommendation/useRecommendationCosts");
const useUpsellCosts = () => {
  const costs = (0, _useRecommendationCosts.useRecommendationCosts)();
  const {
    handset,
    plan,
    upsell,
    connectivityPlan,
    broadband,
    businessSolution
  } = costs;
  const products = [handset, plan, ...((upsell === null || upsell === void 0 ? void 0 : upsell.items) || []), connectivityPlan, broadband, businessSolution].filter(item => {
    return item !== undefined;
  }).map(product => {
    return {
      name: product.name,
      price: product.price,
      productType: product.productType,
      selectedPrice: product.selectedPrice
    };
  });
  return {
    products
  };
};
var _default = useUpsellCosts;
exports.default = _default;